import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireDatabase } from "@angular/fire/database";
import { Router } from '@angular/router';
import { UsuarioService } from '../../../services/usuario.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';

import * as firebase from 'firebase';

@Component({
    selector: 'app-confirmar-pagamento-dialog',
    templateUrl: './confirmar-pagamento-dialog.html',
    styleUrls: ['./confirmar-pagamento-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlterarPagamentosDemandaDialog {
    uid;
    selectable = true;
    removable = true;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    numerosCtrl = new FormControl();
    numerosPedidos: string[] = [];
    numeroMaximoContPedidos: Number;
    bConsulta: boolean = false;
    totalIndividualProdutosComprados = [];
    contTotalProdutosGeral: number = 0;
    sErrosAlteracao = [];

    constructor(
        private toastr: ToastrService,
        private dialogRef: MatDialogRef<AlterarPagamentosDemandaDialog>,
        private spinner: NgxSpinnerService,
        private db: AngularFireDatabase,
        private router: Router,
        private usuarioService: UsuarioService) {
        this.uid = localStorage.getItem('uid');

        this.usuarioService.getContIdPedidos().subscribe(snap => {
            const cont: any = snap;
            this.numeroMaximoContPedidos = cont;
        });
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (!this.numerosPedidos.includes(value)) {
            if (Number(value) <= this.numeroMaximoContPedidos && Number(value) >= 1) {
                this.numerosPedidos.push(value);
            } else
                this.toastr.warning('Este pedido não existe', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        } else
            this.toastr.warning('Você já adicionou este pedido à lista', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

        // Clear the input value
        event.value = '';

        this.numerosCtrl.setValue(null);
    }

    remove(fruit: string): void {
        const index = this.numerosPedidos.indexOf(fruit);

        if (index >= 0) {
            this.numerosPedidos.splice(index, 1);
        }
    }

    confirmarPagamentos() {
        if (this.numerosPedidos.length > 0) {
            this.spinner.show('default');
            this.toastr.warning('Um momento enquanto a alteração em demanda é aplicada...', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

            setTimeout(() => {
                Promise.all(this.numerosPedidos.map(async (idPedido) => {
                    this.db.object('Clientes/' + this.uid + '/Pedidos/' + idPedido).query.ref.transaction(dadosPedido => {
                        if (dadosPedido) {
                            if (dadosPedido.Status !== 'Cancelado' && dadosPedido.StatusPagamento === 'Pendente' && dadosPedido.FormaPagamento !== 'Boleto') {

                                dadosPedido.StatusPagamento = 'Pago';
                                return dadosPedido;
                            } else {
                                this.sErrosAlteracao.push(idPedido);
                                return dadosPedido;
                            }
                        }
                        return dadosPedido;
                    }).catch(err => {
                        this.sErrosAlteracao.push(idPedido);
                        this.finalizarProcesso(false, err);
                    });
                })).finally(() => {
                    this.finalizarProcesso(true, null);
                }).catch(err => {
                    this.finalizarProcesso(false, err);
                    console.log(err);
                    console.log(this.sErrosAlteracao);
                });
            }, 500);
        } else
            this.toastr.error("Não há pedidos para realizar a alteração de status!", 'Erro');
    }

    finalizarProcesso(b, err) {
        console.log(b)
        console.log(err)
        console.log(this.sErrosAlteracao)
        //Finaliza o processo
        setTimeout(() => {
            const map = {
                PedidosAlterarStatusPagamento: this.numerosPedidos,
                Erros: this.sErrosAlteracao,
                Err: err
            }

            this.usuarioService.setLog("Confirmação de pagamento em demanda", map, this.uid);

            this.dialogRef.close();
            this.toastr.clear();
            if (this.sErrosAlteracao.length === 0 && b) {
                this.toastr.success('Todos os pagamentos foram confirmados com sucesso!', 'Status', { progressBar: false, positionClass: 'toast-top-center', });
            } else {
                alert('Houve um erro na confirmação do pagamento no(s) pedido(s): \n\n' + this.sErrosAlteracao + '. \n\nANOTE ESTE DADO E CONFIRA OS PEDIDOS\n\n Pode ter havido uma falha na alteração ou o status do pagamento já havia sido alterado.');
            }
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/consultar-pedidos"]));

            setTimeout(() => this.spinner.hide('default'), 300);
        }, 3000)
    }

    cancelar() {
        this.dialogRef.close();
    }

}
